<kendo-appbar position="bottom" style="height: 40px;" positionMode="static">
    <kendo-appbar-section>
        <span>Epc, Inc. &copy; 2024</span>
    </kendo-appbar-section>
    <kendo-appbar-section>
        <span>Organization: </span><button kendoButton class="btnOrganization">{{ organizationName }}</button>
    </kendo-appbar-section>
</kendo-appbar>
